import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, Observable, throwError, tap } from 'rxjs';
import { MatchRun } from '../interfaces/matchRun';
import { MatchingPeriodService } from './matchingPeriod.service';

@Injectable({
  providedIn: 'root'
})
export class MatchRunService {
  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private matchingPeriodService: MatchingPeriodService
  ) {}

  startMatchrun(comment?: string, matchRunId?: string, isMajorMatchrun?: boolean): Observable<void> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body: any = {};
    if (comment) {
      body.comment = comment;
    }
    if (matchRunId) {
      body.matchRunId = matchRunId;
    }
    if (isMajorMatchrun) {
      body.isMajorMatchrun = isMajorMatchrun;
    }
    return this.http.post<void>(`${environment.apiUrl}admin/start-matchrun`, body, { headers }).pipe(
      tap(() => {
        // Clear cache so the latest matchrun will be fetched with fresh data
        this.matchingPeriodService.clearLatestMatchingPeriodCache();
      }),
      catchError((error) => {
        console.error('Error starting matchrun:', error);
        // Pass through the error message from the backend
        const errorMessage = error.error?.message || error.error?.error || 'Failed to start matchrun';
        return throwError(() => new Error(errorMessage));
      })
    );
  }

  checkParticipantWarnings(): Observable<{
    canStartMatchrun: boolean;
    message: string;
    participants: Array<{ id: string; enisNumber: string; type: 'donor' | 'recipient'; warnings: string[] }>;
  }> {
    return this.http.get<{
      canStartMatchrun: boolean;
      message: string;
      participants: Array<{ id: string; enisNumber: string; type: 'donor' | 'recipient'; warnings: string[] }>;
    }>(`${environment.apiUrl}admin/check-participant-warnings`);
  }

  getMatchRunStatus() {
    return this.http.get<string>(`${environment.apiUrl}admin/matchrun-status`);
  }

  getSettings() {
    return this.http.get<any>(`${environment.apiUrl}admin/settings`);
  }

  setSettings(updatedSettings: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}admin/settings`, updatedSettings);
  }

  getMatchrunExcelfiles(timestamp: string): Observable<string[]> {
    const url = `${environment.apiUrl}admin/download-s3-excel-files?timestamp=${timestamp}`;

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<{ signedUrls: string[] }>(url, { headers }).pipe(
      map((response) => response.signedUrls), // Extract the signed URLs from the response
      catchError((error) => {
        console.error('Failed to fetch signed URLs:', error);
        return throwError(() => new Error('Failed to fetch signed URLs'));
      })
    );
  }
}
